<!--
  工单详情
-->
<template>
  <div class="box-page" v-loading="loading">
    <template v-if="detail && !loading">
      <div class="flex-c-s box-title-line">
        <div class="detail-nav flex-col-center">
          <div style="cursor: pointer" @click="goBack">工单列表</div>
          <div class="nav-icon"></div>
          <div class="nav-now">工单详情</div>
        </div>
      </div>

      <el-steps :active="stepActive" finish-status="success" simple
        :process-status="stepActive == steps.length - 1 ? 'success' : 'process'" style="margin: 30px 0">
        <el-step :title="item.title" v-for="(item, index) in steps" :key="index"></el-step>
      </el-steps>

      <div class="content-title">工单信息</div>
      <div class="order-detail">
        <div class="flex-c-s">
          <div class="flex-col-center">
            <el-tag type="warning" v-if="detail.status == 0">待分配</el-tag>
            <el-tag type="warning" v-else-if="detail.status == 1">待接单</el-tag>
            <el-tag v-else-if="detail.status == 2">处理中</el-tag>
            <el-tag v-else-if="detail.status == 3">待验收</el-tag>
            <el-tag type="success" v-else-if="detail.status == 4">已完成</el-tag>
            <el-tag type="danger" v-else-if="detail.status == 5">已撤消</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
            <el-tag v-if="detail.isAutoDistribute === '1'" type="success" class="ml10">自动分配</el-tag>
            <el-tag v-if="detail.isFocus === '1'" type="danger" class="ml10">验收不通过</el-tag>
            <div class="order-title" style="margin-right: 0; margin-left: 16px">
              {{ detail.sheetTitle }}
            </div>
            <div style="
                margin-left: 28px;
                font-size: 14px;
                color: rgba(41, 48, 82, 0.7);
              ">
              <span class="mr20">工单编号：{{ detail.sheetNumber }}</span>
              <span>发起客户: {{ detail.adminUserName }}</span>
              <span style="margin: 0 27px">|</span> 发起人：{{
                detail.clientUserName
              }}
            </div>
          </div>
          <div class="box-btn turn-btn" v-if="(detail.status === '0'||detail.status === '1') && detail.isFocus !== '1' && detail.isOperationSheet == '1'" @click="cancelOrder">
            撤销工单
          </div>
          <div class="box-btn" v-if="detail.status == '3' && detail.isOperationSheet == '1'" @click="openSubmit">
            验收工单
          </div>
        </div>

        <el-row class="detail-content" :gutter="20">
          <el-col :lg="6" :md="8" :sm="12" :xs="12">
            <div>联系人: {{ detail.contactUserName }}</div>
            <div>联系电话：{{ detail.contactTel }}</div>
          </el-col>
          <el-col :lg="6" :md="8" :sm="12" :xs="12">
            <div>分配人：服务台</div>
            <el-tooltip :content="detail.distributeTime" :disabled="!detail.distributeTime" placement="top">
              <div class="text-hidden">分配时间：{{ detail.distributeTime || '--' }}</div>
            </el-tooltip>
          </el-col>
          <el-col :lg="6" :md="8" :sm="12" :xs="12">
            <div>处理人：{{ detail.receiveUserName || '--' }}</div>
            <el-tooltip :content="detail.receiveTime" :disabled="!detail.receiveTime" placement="top">
              <div class="text-hidden">处理时间：{{ detail.receiveTime || '--' }}</div>
            </el-tooltip>
          </el-col>
          <el-col :lg="6" :md="8" :sm="12" :xs="12">
            <div>期望完成时间</div>
            <div class="work-time text-hidden">{{ detail.hopeCompleteTime || '--' }}</div>
          </el-col>
          <el-col :lg="6" :md="8" :sm="12" :xs="12" v-if="detail.expectedCompleteTime">
            <div>预计完成时间</div>
            <div class="work-time">{{ detail.expectedCompleteTime }}</div>
          </el-col>
          <el-col :lg="6" :md="8" :sm="12" :xs="12">
            <div>工单耗时</div>
            <div class="work-time">{{ detail.sheetUseTime }}</div>
          </el-col>
		  <el-col :lg="6" :md="8" :sm="12" :xs="12" v-if="detail.receiveUserName">
			<div>处理人电话：{{ detail.receiveUserPhone || '--' }}</div>
		  </el-col>
        </el-row>
        <div class="detail-line"></div>
        <div class="flex-row-sb">
          <div style="flex: 1">
            <div class="detaile-time">发起时间：{{ detail.startTime }}</div>
            <!-- 故障原因 -->
            <div class="failure-height" :style="isUnfold ? 'max-height:999px' : 'max-height:100px'">
              <failure-cause class="content-val" :failure="detail.questions" ref="failureCause"></failure-cause>
            </div>
          </div>
          <div class="order-serve" v-if="isNotOperate" @click="openServe">
            <img src="@/assets/images/home_icon_pl.png" />
            <span>发起咨询</span>
          </div>
        </div>
        <div class="unfold-icon" v-if="showTag" @click="isUnfold = !isUnfold">
          <div style="margin-right:5px">{{ isUnfold ? '收起' : '展开' }}</div>
          <div :class="isUnfold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" style="font-weight:bold"></div>
        </div>
      </div>

      <!-- 处理结果 -->
      <detail-result v-if="detail.result" :result="detail.result"></detail-result>

      <!-- 验收评价 -->
      <detail-eva v-if="detail.evaluate" :evaluate="detail.evaluate"></detail-eva>

      <div class="flex" style="margin-top: 40px">
        <div class="menu-title" :style="menuActive == index ? 'color:#40424F' : ''" v-for="(item, index) in menu"
          :key="index" @click="changeMenu(index)">
          {{ item }}
          <div class="title-icon" v-if="index == 2 && detail.unReadCount > 0">{{ detail.unReadCount }}</div>
        </div>
      </div>

      <!-- 工单日志 -->
      <detail-order-log :id="id" ref="orderLog" v-show="menuActive == 0"></detail-order-log>

      <!-- 追踪日志 -->
      <detail-tracking-log :id="id" ref="trackingLog" v-show="menuActive == 1"></detail-tracking-log>

      <!-- 回复记录 -->
      <detail-reply-log :id="id" ref="replyLog" v-show="menuActive == 2"></detail-reply-log>

      <!-- 发起咨询 -->
      <detail-consult @refresh="refresh" ref="detailConsult"></detail-consult>

      <!-- 验收工单 -->
      <acceptance-order @refresh="refresh" ref="acceptanceOrder"></acceptance-order>
    </template>
  </div>
</template>

<script>
import DetailResult from '@/components/WorkOrder/DetailResult'
import DetailEva from '@/components/WorkOrder/DetailEva'
import DetailOrderLog from '@/components/WorkOrder/DetailOrderLog'
import DetailTrackingLog from '@/components/WorkOrder/DetailTrackingLog'
import DetailReplyLog from '@/components/WorkOrder/DetailReplyLog'
import FailureCause from '@/components/WorkOrder/FailureCause'
import DetailConsult from '@/components/WorkOrder/DetailConsult.vue'
import AcceptanceOrder from '@/components/WorkOrder/AcceptanceOrder.vue'

export default {
  components: {
    DetailResult,
    DetailEva,
    DetailOrderLog,
    DetailTrackingLog,
    DetailReplyLog,
    FailureCause,
    DetailConsult,
    AcceptanceOrder
  },
  data() {
    return {
      id: '', // 工单id
      detail: null, // 工单详情
      loading: false,

      searchValue: '', // 搜索内容
      menu: ['处理记录', '追踪记录', '沟通记录'],
      menuActive: 0,

      // 进度条
      steps: [
        { id: '0', title: '待分配' },
        { id: '1', title: '待接单' },
        { id: '2', title: '处理中' },
        { id: '3', title: '待验收' },
        { id: '4', title: '已完成' }
      ],

      showTag: false, // 是否显示展开收起
      isUnfold: false // 是否展开
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userType
    },
    // 进度条当前进度
    stepActive() {
      if (this.detail) {
        for (let i = 0; i < this.steps.length; i++) {
          const item = this.steps[i]
          if (item.id == this.detail.status) {
            return i
          }
        }
      }
      return 0
    },
    // 工单是否处于已完成或已撤销
    isNotOperate() {
      if (this.detail) {
        return this.detail.status != '4' && this.detail.status != '5'
      } else {
        return false
      }
    }
  },
  watch: {
    // 解决从消息列表多次点击跳转到详情数据不刷新问题
    $route() {
      this.refresh()
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getOrderDetail()
  },
  methods: {
    // 获取工单详情
    getOrderDetail() {
      this.loading = true

      this.$api.order
        .sheetDetail(this.id)
        .then(({ data }) => {
          this.loading = false
          if (data.code == 200) {
            this.detail = data.data
            // 每次进入详情，后端会自动已读关于这条工单的消息，所以需要重新获取消息列表和消息未读数
            this.$store.commit('getMessageUnReadCount')
            this.$store.dispatch('getMessageList')
            // 获取故障原因高度 超高显示展开收起
            this.$nextTick(() => {
              const height = this.$refs.failureCause.$el.offsetHeight
              if (height > 100) {
                this.showTag = true
              }
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 刷新
    refresh() {
      this.getOrderDetail()
      this.$refs.orderLog.getList()
      this.$refs.trackingLog.getList()
      this.$refs.replyLog.getList()
    },

    // 发起咨询
    openServe() {
      this.$refs.detailConsult.open(this.detail)
    },

    // 验收工单
    openSubmit() {
      this.$refs.acceptanceOrder.open(this.detail)
    },

    // 撤销工单
    cancelOrder() {
      this.$confirm('此操作将撤销该工单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.order.cancelSheet(this.id).then(({ data }) => {
            if (data.code == 200) {
              this.$notify.success({
                title: '提示',
                message: '撤销成功'
              })
              this.refresh()
            }
          })
        })
        .catch(() => {})
    },

    changeMenu(index) {
      this.menuActive = index
      if (index == 2 && this.detail.unReadCount > 0) this.replayAllRead()
    },

    // 回复记录全部已读
    replayAllRead() {
      this.$api.order.replayAllRead(this.id).then(({ data }) => {
        if (data.code == 200) this.detail.unReadCount = 0
      })
    },

    goBack() {
      this.$router.back()
    }
  }
}
</script>
<style>
.content-title {
  margin-bottom: 22px;
  font-size: 18px;
  color: #40424f;
}

.order-line {
  border-bottom: 1px dashed rgba(64, 66, 79, 0.2);
}

.user-header {
  width: 30px;
  height: 30px;
  margin-right: 17px;
  border-radius: 50%;
}

.user-name {
  font-size: 14px;
  color: #333333;
}

.create-time {
  font-size: 14px;
  color: #293052;
}
</style>

<style lang="scss" scoped>
.detail-nav {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 0.4);
  .nav-icon {
    width: 7px;
    height: 7px;
    margin: 0 16px;
    border-right: 2px solid rgba(64, 66, 79, 0.4);
    border-bottom: 2px solid rgba(64, 66, 79, 0.4);
    transform: rotate(-45deg);
  }
  .nav-now {
    color: #333333;
  }
}

.work-steps {
  margin: 49px 0 60px 0;
}

.order-detail {
  padding: 25px 30px 20px 30px;
  background-color: rgba(241, 243, 255, 0.6);
  border-radius: 10px;
  .order-title {
    margin-right: 14px;
    font-size: 16px;
    font-weight: bold;
    color: #293052;
  }
  .turn-btn {
    margin-right: 20px;
    background: #f7f8ff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    color: #666666;
  }
  .order-text {
    flex: 1;
    margin-right: 2rem;
    margin-top: 10px;
    font-size: 14px;
    color: rgba(41, 48, 82, 0.7);
    line-height: 30px;
  }
  .order-time {
    font-size: 20px;
    font-family: 'DIN';
    color: #3885ff;
  }
}
.order-serve {
  margin-left: 40px;
  padding-right: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  line-height: 30px;
  color: rgba(41, 48, 82, 0.7);
  cursor: pointer;
  img {
    width: 23px;
    height: 23px;
    object-fit: contain;
    margin-right: 12px;
  }
}

.menu-title {
  margin-right: 173px;
  font-size: 18px;
  color: rgba(64, 66, 79, 0.5);
  cursor: pointer;
  position: relative;
  &:last-child {
    margin-right: 0;
  }
  .title-icon {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgb(230, 46, 46);
    color: #fff;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
}

.division-icon {
  margin: 0 0.26rem;
}
// 详情CSS
.detail-content {
  margin-top: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(41, 48, 82, 0.7);
  line-height: 30px;
  .work-time {
    font-size: 20px;
    font-family: DIN;
    font-weight: bold;
    color: #3885ff;
  }
  .content-btns > img {
    width: 23px;
    height: 23px;
    object-fit: contain;
    margin-right: 19px;
    cursor: pointer;
    opacity: 0.5;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      opacity: 1;
    }
  }
}
.detaile-time {
  font-size: 14px;
  font-weight: 500;
  color: rgba(41, 48, 82, 0.7);
  line-height: 30px;
}
.content-val {
  line-height: 25px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(41, 48, 82, 0.7);
  span {
    color: #3885ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.detail-line {
  height: 1px;
  margin: 24px 0 20px 0;
  border-bottom: 1px dashed #293052;
  opacity: 0.15;
}
.unfold-icon {
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.failure-height {
  overflow: hidden;
  transition: all 0.5s;
}
</style>
